import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchCarrierM39ComplianceOperator = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getCarrierM39ComplianceOperator',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchCarrierM39ComplianceOperator;
